<main class="login-page">
	<div class="background-accent background-accent--top" aria-hidden="true"></div>
	<div class="background-accent background-accent--bottom" aria-hidden="true"></div>

	<section class="login-card" aria-labelledby="login-title">
		<header class="login-header">
			<h1 id="login-title">Back Office Login</h1>
		</header>

		<form [formGroup]="form" (ngSubmit)="submit()">
			<label>
				<span>Όνομα χρήστη</span>
				<input
					formControlName="username"
					autocomplete="username"
				/>
			</label>

			<label>
				<span>Κωδικός πρόσβασης</span>
				<input
					type="password"
					formControlName="password"
					autocomplete="current-password"
				/>
			</label>

			<button type="submit" [disabled]="form.invalid || busy()">
				{{ busy() ? 'Σύνδεση…' : 'Σύνδεση' }}
			</button>
		</form>
	</section>
</main>
